import React, { useState, useRef } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
} from "reactstrap";
import axios from "axios";
import Swal from "sweetalert2";

const ModalCreate = ({
  isOpen,
  toggle,
  title,
  token,
  fetchData,
}) => {
  const [ips, setIps] = useState("");
  const [direccion, setDireccion] = useState("");
  const [, setFormMode] = useState("none");
  const modalRef = useRef(null);

  const handleIpsChange = (event) => {
    setIps(event.target.value);
  };
  const handleDireccionChange = (event) => {
    setDireccion(event.target.value);
  };

  const handleCreateSubmit = (event) => {
    event.preventDefault();

    // Enviar los datos de ls IPs
    axios
      .post("/ips", {
        Texto: ips,
        Direccion: direccion,
      }, {headers: { Authorization: `Bearer ${token}` }})
      .then((response) => {
        Swal.fire({
          icon: "success",
          title: "Creado!",
          text: "La IPS ha sido creada con exito",
          showCloseButton: true,
        }).then(() => {
          fetchData();
        });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: "Ha ocurrido un error al crear la IPS.",
          showCloseButton: true,
        });
      });
  };

  return (
    <Modal ref={modalRef} isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>{title}</ModalHeader>
      <ModalBody>
        <FormGroup>
          <label>IPS:</label>
          <input
            className="form-control"
            name="nombre"
            type="text"
            value={ips}
            onChange={handleIpsChange}
          />
        </FormGroup>
        <FormGroup>
          <label>Dirección:</label>
          <input
            className="form-control"
            name="nombre"
            type="text"
            value={direccion}
            onChange={handleDireccionChange}
          />
        </FormGroup>
      </ModalBody>

      <ModalFooter>
        <Button onClick={handleCreateSubmit} color="primary" otype="submit">
          Insertar
        </Button>
        <Button color="danger" onClick={() => setFormMode("none")}>
          Cancelar
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ModalCreate;
